import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { TPreviewReachParams, TPreviewReachResponse } from './types';

const SERVICE_ALERT_REACH_PREVIEW_URL = 'service-alerts/preview-reach';

export function useServiceAlertReachPreview({
  serviceCategory,
  serviceSubcategory,
  serviceCompositeIds = [],
}: TPreviewReachParams) {
  const body = {
    serviceCategory: serviceCategory ?? undefined,
    serviceSubcategory: serviceSubcategory ?? undefined,
    serviceCompositeIds,
  };

  const { data, error, isLoading } = useSWR<TPreviewReachResponse>(
    [
      SERVICE_ALERT_REACH_PREVIEW_URL,
      serviceCategory ?? '',
      serviceSubcategory ?? '',
      serviceCompositeIds.join(','),
    ],
    () =>
      SWRFetcher({ method: 'POST', body })(SERVICE_ALERT_REACH_PREVIEW_URL),
    { keepPreviousData: true }
  );

  return { data, error, isLoading };
}
